module.exports = __webpack_public_path__ + "img/arrow.2beef02c.svg";